module.exports = __webpack_public_path__ + "documents/VHDP_Technical_TOS_(Wireless)_(001).pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/VHDP_Technical_TOS_(Wireless)_(001).pdf
// module id = 3535
// module chunks = 0